import { Circle } from 'lucide-react';

import { MENU_ICONS } from './menuIconRegistry';

export function MenuIcon({ name, className }: { name: string; className?: string }) {
  const Icon = MENU_ICONS[name] ?? Circle;
  return <Icon className={className} aria-hidden />;
}
